import { restClient } from '../../client';


export type FormProgressInput = {
  form_key: string | 'PHQ9' | 'GAD7';
};


export type FormProgressOutput = {
  submission_id: number;
  completed: boolean;
  expired: boolean;
  progress: number;
};


export const formProgress = restClient.createRequest<FormProgressInput, FormProgressOutput>({
  url: '/api/v1/form/progress',
  method: 'GET',
});
